<template>
  <div class="login ExamTimeInfo">
    <TopNavBar navtitle="考试时间查询"></TopNavBar>
    <div class="exambatch">
      <van-cell-group>
        <van-field
          readonly
          clickable
          left-icon="todo-list-o"
          name="picker"
          :value="value"
          label="报考批次"
          placeholder="点击选择报考批次"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" position="bottom">
          <van-picker
            show-toolbar
            :columns="columns"
            @confirm="onConfirm"
            @cancel="showPicker = false"
          />
        </van-popup>
        <van-field
          v-model="CertNo"
          clearable
          label="证件号"
          left-icon="idcard"
          placeholder="请输入证件号"
        />
        <div class="ExamResultbtn">
          <van-button type="primary" @click="SelectExam" size="normal"
            >立即查询</van-button
          >
        </div>
      </van-cell-group>
    </div>
    <div class="enrolllist">
      <ul v-for="item in ExamFormList" :key="item.EF_ID">
        <h1>{{ item.ExamBatch.EB_Name }}</h1>
        <img class="papers" :src="item.Photo" alt />
        <li>
          <label for> <i class="iconfont icon-baoming"></i>报考人： </label>
          <span>{{ item.Name }}</span>
        </li>
        <li>
          <label for> <i class="iconfont icon-zhuanye"></i>报考专业： </label>
          <span>{{ item.Majors.MName }}</span>
        </li>
        <li>
          <label for> <i class="iconfont icon-dengji"></i>报考等级： </label>
          <span>{{ item.Grades.GName }}</span>
        </li>

        <li
          v-if="
            new Date(item.ExamBatch.ShowRoomTime.replace(/-/g, '/')) <
              new Date() &&
              item.ExamTime &&
              item.ExamTime.IsPub == 1
          "
        >
          <label for> <i class="iconfont icon-didian"></i>考场： </label>
          <span class="warning">{{ item.ExamTime.ExamRoom }}</span>
        </li>
        <li
          v-if="
            new Date(item.ExamBatch.ShowRoomTime.replace(/-/g, '/')) <
              new Date() &&
              item.ExamTime &&
              item.ExamTime.IsPub == 1 &&
              item.ExamTime.IsOnline == 0
          "
        >
          <label for> <i class="iconfont icon-riqi"></i>考试时间： </label>
          <span class="warning"
            >{{ item.ExamTime.ExamBeginDate.split(" ")[0] }} </br>
            {{ item.ExamTime.ExamBeginDate.split(" ")[1] }} -
            {{ item.ExamTime.ExamEndDate.split(" ")[1]}}</span
          >
        </li>
        <li
          v-if="
            new Date(item.ExamBatch.ShowRoomTime.replace(/-/g, '/')) <
              new Date() &&
              item.ExamTime &&
              item.ExamTime.IsPub == 1 &&
              item.ExamTime.IsOnline == 1
          "
        >
          <label for>
            <i class="iconfont icon-riqi"></i>上传视频开始时间：
          </label>
          <span class="warning">{{ item.ExamTime.ExamBeginDate }}</span>
        </li>
        <li
          v-if="
            new Date(item.ExamBatch.ShowRoomTime.replace(/-/g, '/')) <
              new Date() &&
              item.ExamTime &&
              item.ExamTime.IsPub == 1 &&
              item.ExamTime.IsOnline == 1
          "
        >
          <label for>
            <i class="iconfont icon-riqi"></i>上传视频截止时间：
          </label>
          <span class="warning">{{ item.ExamTime.ExamEndDate }}</span>
        </li>
        <li
          v-if="
            new Date(item.ExamBatch.ShowRoomTime.replace(/-/g, '/')) <
              new Date() &&
              item.ExamTime &&
              item.ExamTime.IsPub == 1 &&
              item.ExamTime.IsOnline == 0
          "
        >
          <label for> <i class="iconfont icon-didian"></i>考试地点：</label>
          <span class="warning">{{ item.ExamTime.ExamAddress }}</span>
        </li>

        <van-button
          v-if="
            new Date(item.ExamBatch.ShowRoomTime.replace(/-/g, '/')) <
              new Date() &&
              item.ExamTime &&
              item.ExamTime.IsPub == 1 &&
              item.ExamTime.IsOnline == 0
          "
          type="primary"
          style="width: 50vw;margin-top: 20px;"
          @click="ShowQR(item)"
          size="normal"
          >现场考试码</van-button
        >
 <van-button
          v-if="
            new Date(item.ExamBatch.ShowRoomTime.replace(/-/g, '/')) <
              new Date() &&
              item.ExamTime &&
              item.ExamTime.IsPub == 1 &&
              item.ExamTime.IsOnline == 0
          "
          type="primary"
          style="width: 50vw;margin-top: 20px;"
         :to="'/SetOfflineExamTracks?EF_ID=' + item.EF_ID"
          size="normal"
          >选择考试曲目</van-button>
          
          
          <van-button
             type="primary"
          style="width: 50vw;margin-top: 20px;"
                v-if="
            new Date(item.ExamBatch.ShowRoomTime.replace(/-/g, '/')) <
              new Date() &&
              item.ExamTime &&
              item.ExamTime.IsPub == 1 &&
              item.ExamTime.IsOnline == 0
          "
                @click="OpenTicket(item.EF_ID)"
              >
                <i class="iconfont icon-zhunkaozheng"></i>准考证
              </van-button>
        <li
          v-if="
            new Date(item.ExamBatch.ShowRoomTime.replace(/-/g, '/')) >
              new Date()
          "
        >
          <label><i class="iconfont icon-riqi"></i>查看考场时间</label>
          <span class="warning"
            >{{
              item.ExamBatch.ShowRoomTime.replace(/-/g, "/").split(" ")[0]
            }}——{{
              new Date(
                item.ExamBatch.ShowRoomTime.replace(/-/g, "/")
              ).getFullYear()
            }}-{{
              new Date(
                item.ExamBatch.ShowRoomTime.replace(/-/g, "/")
              ).getMonth() +
                1 >
              10
                ? new Date(
                    item.ExamBatch.ShowRoomTime.replace(/-/g, "/")
                  ).getMonth() +
                  1 +
                  ""
                : "" +
                  new Date(
                    item.ExamBatch.ShowRoomTime.replace(/-/g, "/")
                  ).getMonth() +
                  1
            }}-{{
              new Date(
                item.ExamBatch.ShowRoomTime.replace(/-/g, "/")
              ).getDate() + 7
            }}</span
          >
        </li>
      </ul>
      <!-- 如果没有数据时显示 -->
      <van-empty
        v-if="!ExamFormList || ExamFormList.length == 0"
        description="暂无数据"
      ></van-empty>
    </div>
    <van-popup v-model="QrOption.IsShow">
      <div v-if="QrOption.text" v-qr="QrOption"></div
    ></van-popup>
        <van-dialog
      v-model="showTicket"
      className="Ticket"
      title="准考证"
      message-align="left"
      confirm-button-text="关闭"
    >
      <div>
        <Ticket :EF_ID="STEF_ID" v-if="showTicket"></Ticket>
      </div>
    </van-dialog>
  </div>
</template>

<script>

import TopNavBar from "@/components/TopNavBar.vue";
import AESUtil from "../Utils/AES.js";
import Ticket from "@/components/Ticket.vue";
import { GetALLExamBatchMenuList, FindExamFormInfo } from "@/api/exam";
export default {
  components: {
    TopNavBar,
    Ticket
  },
  data() {
    return {
      showTicket: false,
      STEF_ID: null,
      value: null,
      EB_ID: null,
      CertNo: null,
      columns: [],
      showPicker: false,
      EBList: null,
      ExamFormList: null,
      QrOption: { text: "", width: 250, height: 250, IsShow: false }
    };
  },
  created() {
    this.GetALLExamBatchMenuList();
  },
  methods: {
      OpenTicket(EF_ID) {
      this.STEF_ID = EF_ID;
      this.showTicket = true;
    },
    ShowQR(item) {
      var key = process.env.VUE_APP_KEY;
      let parms = {
        EF_ID: item.EF_ID,
        Name: item.Name,
        MName: item.Majors.MName,
        GName: item.Grades.GName,
        ExamNO: item.ExamNO
      };

      this.QrOption.IsShow = true;
      this.QrOption.text =encodeURIComponent(AESUtil.encryptAES(JSON.stringify(parms)));;
    },
    onConfirm(value) {
      this.value = value;
      this.EB_ID = this.EBList.filter(s => s.EB_Name == value)[0].EB_ID;
      this.showPicker = false;
    },
    GetALLExamBatchMenuList() {
      GetALLExamBatchMenuList().then(result => {
        this.EBList = result.listData;

        result.listData.forEach(element => {
          this.columns.push(element.EB_Name);
        });
      });
    },
    SelectExam() {
      if (!this.EB_ID) {
        this.$toast.fail("请选择批次");
        return;
      }
      if (!this.CertNo) {
        this.$toast.fail("请输入证件号");
        return;
      }
      FindExamFormInfo({ EB_ID: this.EB_ID, CertNO: this.CertNo }).then(res => {
        this.ExamFormList = res.listData;
      });
    }
  }
};
</script>

<style>
.ExamTimeInfo {
  background: url(../assets/kscj.jpg) top no-repeat !important;
  background-size: contain !important;
  min-height: 60vh;
  width: 100%;
}
.ExamTimeInfo .van-cell-group {
  margin: 6vh auto 0;
  border-radius: 15px 15px 0 0;
}
.ExamTimeInfo .exambatch {
  width: 96%;
  margin: 10px auto;
}
.ExamTimeInfo .exambatch .van-cell-group .van-cell {
  border-radius: 8px;
}
.ExamTimeInfo .exambatch .van-hairline--top-bottom::after,
.ExamTimeInfo .exambatch .van-hairline-unset--top-bottom::after {
  border: 0;
}
.exambatch .van-dropdown-menu .van-dropdown-menu__title--active,
.exambatch .van-dropdown-menu .van-dropdown-menu__title {
  color: #333;
  font-weight: bold;
}
.warning {
  width: 50vw;
}
</style>
